import type { FaireProductEntity } from "../../entity_types/product";

export const p_d6wxnhfp: FaireProductEntity = {
  token: "p_d6wxnhfp",
  type: "product",
  name: "Automatic Dishwasher Powder",
  brandToken: "b_1kcui4ks",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/d107b3b33b7269e3554ac28a5b08374be6929a8f1ac391e86243283d2a873d54.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/b918032201d7625b56d4d265bf053656beb8d04654ab629453ffd4c39b022bf5/1551153499.jpg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/fc86da7e60f7d9a291376ec34fb998a5589f52f1a76b70d028f6972bcc67f234/1528340210.png",
    "https://cdn.faire.com/fastly/a4e117e16f315be4a2ee87fa9469138936de5049e5fb20c9a7e1a2913867ea4b.jpeg",
    "https://cdn.faire.com/fastly/960b307945b58a8d149ea7bb74c390e6fc01cd9398d1196c6c66dd06086ab342.jpeg",
  ],
  priceDollars: 16,
  description:
    "Tired of etched glassware, white film and not so sparkling dishes? MamaSuds Automatic Dishwasher Powder is made with safe ingredients, vegan, it’s eco-friendly, it’s 100% biodegradable…. And it WORKS! \nEWG's Guide to Healthy Cleaning gave MamaSuds Automatic Dishwasher Powder an A rating!\n\n30  ounces  net  weight\n•INGREDIENTS:  non-GMO  citric  acid,  sodium  percarbonate,  sodium  bicarbonate,  sodium  carbonate.\n\nUse: 1/2 to 2 Tablespoons (depending on water quality) per load. ",
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:25.155Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
